/**
 * Возвращет длину найденных узлов на странице
 *
 * @param {object} options - параметры
 * @param {string} options.selector - селектор, по которому будет осуществляться поиск элементов
 * @returns {number} -
 */

function getNodesLength({ selector }) {
  return document.querySelectorAll(selector).length
}

export default getNodesLength
